// Every row begins with a snapshot of the caller's UserSettings (currency +
// tax regime), then invoice- and position-level fields — mirroring the
// columns `positions_slice_by_range` returns, in the same order.
const userContext = {
  userCurrency: 'GEL',
  userTaxFee: '1',
  userTaxBase: 'turnover',
  userAccountingBasis: 'cash',
  userVatStatus: 'notRegistered',
  userVatBasis: 'invoice',
  userVatThreshold: '100000',
  userVatThresholdWindow: 'rolling12Months',
};

const positionsRows: ReadonlyArray<Record<string, string | null>> = [
  {
    ...userContext,
    invoiceId: 'KqKVhzyHHq2StCc9jbLf',
    invoiceDate: '2022-01-31',
    invoiceNumber: '2',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    positionId: 'MtvrSGXZpV6hw5ohXY25',
    positionName:
      'Provision of software development services under the contract dated 01.01.2022',
    positionPrice: '1000.00',
    positionVat: '0.00',
    positionCurrency: null,
  },
  {
    ...userContext,
    invoiceId: '2WUWx9RkulxrmMuPQCcb',
    invoiceDate: '2022-02-28',
    invoiceNumber: '3',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    positionId: 'MtvrSGXZpV6hw5ohXY25',
    positionName:
      'Provision of software development services under the contract dated 01.01.2022',
    positionPrice: '1000.00',
    positionVat: '0.00',
    positionCurrency: null,
  },
  {
    ...userContext,
    invoiceId: '8yYW320fAfIbkZEpvDau',
    invoiceDate: '2022-03-31',
    invoiceNumber: '4',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    positionId: 'MtvrSGXZpV6hw5ohXY25',
    positionName:
      'Provision of software development services under the contract dated 01.01.2022',
    positionPrice: '1000.00',
    positionVat: '0.00',
    positionCurrency: 'USD',
  },
  {
    ...userContext,
    invoiceId: '8yYW320fAfIbkZEpvDau',
    invoiceDate: '2022-03-31',
    invoiceNumber: '4',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    positionId: 'MtvrSGXZpV6hw5ohXY25',
    positionName:
      'Provision of software development services under the contract dated 01.01.2022',
    positionPrice: '1000.00',
    positionVat: '0.00',
    positionCurrency: 'USD',
  },
];

const positionsQuery = `
  SELECT
  * FROM
  \`invoicemaker-f5e1d.mini_accountant.positions_slice_by_range\`(
    PARSE_TIMESTAMP("%Y%m%d",  "20220101", "Asia/Tbilisi"),
    PARSE_TIMESTAMP("%Y%m%d", "20231231", "Asia/Tbilisi"),
    "Asia/Tbilisi"
  );
  `;

export { positionsRows, positionsQuery };
